import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";


export const ValidationAllPages = createAsyncThunk(
  "ValidationAllPages/ValidationAllPages",
  async (applicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ValidationAllPages/ValidationAllPages",
        {
            applicationInformationId: applicationInformationId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
   
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ValidateAllPages = createSlice({
  name: "ValidateAllPages",
  initialState: {
    ValidateAllPages: {},
    loadingValidateAllPages: false,
    errorValidateAllPages: null,
  },
  reducers: {
    SetValidateAllPages: (state, action) => {
      state.ValidateAllPages = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(ValidationAllPages.pending, (state, action) => {
        state.loadingValidateAllPages = true;
        state.ValidateAllPages = action.payload;
        state.errorValidateAllPages = null;
      })
      .addCase(ValidationAllPages.fulfilled, (state, action) => {
        state.loadingValidateAllPages = false;
        state.ValidateAllPages = action.payload; // Assuming payload has the desired data
      })
      .addCase(ValidationAllPages.rejected, (state, action) => {
        state.loadingValidateAllPages = false;
        state.errorValidateAllPages = action.payload;
      });
  },
});
export const { SetValidateAllPages } = ValidateAllPages.actions;

export default ValidateAllPages.reducer;
